import { OccConfig } from '@spartacus/core';

export const warehousesOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        sortedWarehouses: '/users/${userId}/warehouses/closest?addressPk=${addressPk}',
      } as any,
    },
  },
};